var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FreeMemberRemoval2"},[_c('section-header',{attrs:{"heading":"2","ja":"無料会員削除完了"}}),_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }